import React, { useEffect,Component,useState,useRef } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import {useHistory,Link} from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {ApiService} from '../../containers/Services/apiservice';
import {Watch} from "react-loader-spinner";
let apiServices = new ApiService();
const MutualFundsErrorPage = () =>{
let history = useHistory();
const [spinnerLoading, setSpinnerLoading] = useState(false);
const didMountRef = useRef(true);
useEffect(() => {
if (didMountRef.current) {  
}
didMountRef.current = false;
});
return (
<div>
<div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
        <div className='overlay-box'>     
            <Watch
                color="#ffffff"
                visible={spinnerLoading}
                />
            </div>
                </div>
<Header/>
<Helmet></Helmet>
<title>MutualFunds - Goalstox</title> 
<section>
<div className="container">
  <div className="row justify-content-md-center">
<div className='col-lg-8 tx-center'>
<p>Your ePayEezz is under process please come back later.</p>
{/* <Link to="/bankdetails" className="btn btn-primary newsletter-button">Add Bank Accounts </Link> */}
<Link to="/dashboard" className="btn btn-primary newsletter-button"> Dashboard</Link>
<p style={{marginTop:'20px'}}>OR</p>
<p>You can go for Lumpsum Investment</p> 
{/* " Link for lumpsum investment" */}
<Link to="/mutualfunds/purchase" className="btn btn-primary newsletter-button"> Lumpsum Investment</Link>
</div>
</div>
  </div>
  </section>
<Footer/>
</div>
);
}
export default MutualFundsErrorPage;